
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  return (
    <div className="container flex min-h-[70vh] flex-col items-center justify-center">
      <h1 className="mb-4 text-6xl font-bold text-blog-purple-primary">404</h1>
      <p className="mb-8 text-xl">Page not found</p>
      <p className="mb-8 max-w-md text-center text-muted-foreground">
        The page you are looking for might have been removed or is temporarily unavailable.
      </p>
      <Link to="/">
        <Button>Return to homepage</Button>
      </Link>
    </div>
  );
};

export default NotFound;
